import axios from "axios";
import auth from "../services/auth";
import store from "@/store";
const baseUrl = process.env.VUE_APP_BASE_API + "api/ticket/";
const api = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    "Access-Control-Allow-Credentials": true,
  },
});
api.interceptors.request.use(async (config) => {
  let token = null;
  if (auth.isAuthenticated()) {
    token = auth.getUserLogged()?.token;
  }
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
});
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("error: ", error);
    if (error.response.status == 429) {
      store.dispatch("mostrarAlerta", {
        mensaje:
          "Ha superado el límite de peticiones, debe esperar un momento y volver a intentar.",
        color: "error",
      });
    }

    if (error.response.status === 401) {
      store.dispatch("mostrarAlerta", {
        mensaje: "Su sesión ha expirado, debe volver a iniciar sesión.",
        color: "error",
      });
      auth.cerrarSesion();
    }
    return Promise.reject(error);
  }
);
export default api;
